// extracted by mini-css-extract-plugin
export default {"head":"LandingHeader_head__vofyo","container":"LandingHeader_container__lHagA","logo":"LandingHeader_logo__Cv12J","krs":"LandingHeader_krs__5rB1z"};